<template>
  <div class='child-head'>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="部门" name="first">
        <my-dept v-if="activeName==='first'"></my-dept>
      </el-tab-pane>
      <el-tab-pane label="企业员工" name="second">
        <my-works v-if="activeName==='second'"></my-works>
      </el-tab-pane>
      <el-tab-pane label="企业门卫" name="three">
        <my-guard v-if="activeName==='three'"></my-guard>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import fkmenu from "@/components/fksys/fksysMenu";
import dept from "./nbtxl/dept";
import works from "./nbtxl/works";
import guard from "./nbtxl/guard";

export default {
    components: {
    "my-dept": dept,
    "my-works": works,
    "my-guard": guard
  },
  data() {
    return {
     activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event){
    }
  }
};
</script>

<style>
@import "../../styles/pulish.css";
.lftj_title
{
width:100%;text-align:center;font-size:x-large;font-weight:bold;margin: 15px auto;
}
.lftj_search
{
  width:100%;text-align:center;
}
</style>


// WEBPACK FOOTER //
// src/views/fksys/nbtxl.vue